// Fix for https://github.com/reduxjs/redux-toolkit/issues/1806#issuecomment-1536690651
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import type { WritableDraft } from '@reduxjs/toolkit/node_modules/immer/dist/internal';

import { createRoutineSlice } from '../../utils';

import { NotificationOrNull } from './PortalNotification.types';

const slice = createRoutineSlice({
    name: 'notifications',
    initialState: {
        notification: null as NotificationOrNull,
    },
    extraRoutines: ['loadNotifications'] as const,
    routineReducers: {
        setNotification: {
            TRIGGER(state, payload) {
                state.notification = payload;
            },
        },
    },
});

export default slice.reducer;
export const notificationRoutines = slice.routines;
export const notificationSelectors = { selectNotification: slice.selectors.notification };
